export default __webpack_public_path__ + "static/media/diners_club.8f7100a1.svg";